import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Send, X } from "lucide-react";
import { sendOwnEmail } from "../lib/api";

// A blank email to one contact: paste or write anything. No template, no sequence, no approval step.
export default function ComposeEmail({ prospect, close, onSent }) {
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      await sendOwnEmail(prospect.id, { subject, body });
      toast.success(`Sent to ${prospect.email}`);
      onSent?.({ notes: [prospect.notes, `Emailed: ${subject}`].filter(Boolean).join("\n") });
      close();
    } catch (e) {
      const d = e?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not send the email");
    } finally { setBusy(false); }
  };
  return <div className="modal-backdrop" onClick={close}>
    <div className="modal login-card setup-card" onClick={e => e.stopPropagation()} data-testid="compose-email">
      <button className="modal-close" onClick={close}><X size={16} /></button>
      <h2>Write an email</h2>
      <p>To <b>{prospect.name}</b> ({prospect.email}). Paste or write anything. It goes out as it is, with no template and no approval step.</p>
      <label>Subject<input value={subject} onChange={e => setSubject(e.target.value)} autoFocus data-testid="compose-subject" /></label>
      <label>Message<textarea rows={12} value={body} onChange={e => setBody(e.target.value)} placeholder="Paste or write your email here" data-testid="compose-body" /></label>
      <p className="muted">Your signature, opt-out line and mailing address are added automatically. To use the contact's details, type <code>{"{{first_name}}"}</code> or <code>{"{{company|your team}}"}</code>; plain text needs nothing.</p>
      <button className="primary-button full" onClick={send} disabled={busy || !subject.trim() || !body.trim()} data-testid="compose-send">
        {busy ? <Loader2 size={14} className="spin" /> : <Send size={14} />} Send email</button>
    </div>
  </div>;
}
